import { OwcBackdrop, OwcProgressSpinner, OwcSkeletonLoader } from '@one/react';
import {
  SkeletonNoLoginContentLayout,
  SkeletonNoLoginHeaderLayout,
  SkeletonNoLoginLayout,
} from './skeleton-no-login.style';

export const SkeletonNoLoginComponent: React.FC = () => (
  <>
    <OwcBackdrop disableScrollLock opacity={0.5}>
      <OwcProgressSpinner variant="secondary" size="xxLarge" />
    </OwcBackdrop>
    <SkeletonNoLoginLayout data-testid="skeleton-loading">
      <SkeletonNoLoginHeaderLayout>
        <OwcSkeletonLoader animation variant="text" />
      </SkeletonNoLoginHeaderLayout>
      <SkeletonNoLoginContentLayout>
        <OwcSkeletonLoader animation variant="text" />
      </SkeletonNoLoginContentLayout>
    </SkeletonNoLoginLayout>
  </>
);
